export class SiteAvailabilityState {
  static ACTIVE = 'active';
  static SUSPENDED = 'suspended';
  static LOCKED = 'locked'; // importing or exporting
}

export class ExtractEncryptionMode {
  static ENABLED = 'enabled';
  static DISABLED = 'disabled';
  static ENFORCED = 'enforced';
}
